// 妖精动漫网 - 角色百科数据
export interface AnimeCharacter {
  id: string;
  name: string;
  alias: string;
  title: string;
  workId: string;
  work: string;
  categoryId: string;
  category: string;
  element: string;
  seiyuu: string;
  seiyuuName: string;
  rank: number;
  popularity: number;
  summary: string;
  description: string;
  image: string;
  tags: string[];
}

export const characters: AnimeCharacter[] = [
  {
    id: 'linya',
    name: '琳娅·夜莺',
    alias: 'Linya Nightingale',
    title: '风之精灵使',
    workId: 'wind-spirit',
    work: '风之精灵使',
    categoryId: 'elemental',
    category: '元素精灵',
    element: '风',
    seiyuu: 'moriyama',
    seiyuuName: '森山杏里',
    rank: 1,
    popularity: 98,
    summary: '驾驭气流与风刃的少女精灵使，性格爽朗，是风系角色的高人气代表。',
    description: '琳娅·夜莺是《风之精灵使》的核心主角，自小在云端秘境「岚之塔」修行，能借助风之契约召唤旋风、空气刃与天翼。她性情外放、行动力极强，却对伙伴格外细腻。琳娅的名场面「逆风而行」以万米高空斩落风魔巨鹰，至今仍是弹幕区的高燃回放。她亦是风系角色人气榜的常客，凭借标志性的墨绿色披风与湛蓝发色深入人心。',
    image: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20confident%20female%20wind%20spirit%20mage%20with%20sea%20blue%20hair%20and%20emerald%20green%20cape%2C%20glowing%20wind%20currents%20swirling%20around%20her%20hands%2C%20standing%20on%20a%20cloud%20peak%20above%20a%20fantasy%20sky%2C%20soft%20painterly%20magical%20style%2C%20emerald%20and%20gold%20palette%2C%20clean%20minimal%20background&width=600&height=800&seq=char-linya&orientation=portrait',
    tags: ['风系', '主角', '飒爽', '高人气'],
  },
  {
    id: 'flora',
    name: '芙洛拉·蔷薇',
    alias: 'Flora Rose',
    title: '花冠女王',
    workId: 'flower-crown',
    work: '花冠物语',
    categoryId: 'flower-fairy',
    category: '花之妖精',
    element: '蔷薇',
    seiyuu: 'shiraishi',
    seiyuuName: '白石结衣',
    rank: 2,
    popularity: 95,
    summary: '掌管万花庭院的蔷薇妖精女王，温柔外表下藏着坚韧的花之意志。',
    description: '芙洛拉·蔷薇是《花冠物语》的女主角，生长于永不凋谢的「万花庭院」，身负守护花界平衡的使命。她能驱使荆棘、绽放治愈之花，也能以花语预知季节更替。芙洛拉的配音细腻温润，将「花冠加冕」场景中的哽咽与坚定演绎得层次分明。其标志性的浅金卷发与玫瑰发冠，已成为花系角色的代表性符号。',
    image: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20graceful%20flower%20fairy%20queen%20with%20golden%20curly%20hair%20and%20a%20rose%20crown%2C%20gentle%20smile%2C%20surrounded%20by%20blooming%20pink%20and%20cream%20roses%20and%20floating%20petals%2C%20soft%20painterly%20magical%20style%2C%20warm%20cream%20and%20gold%20palette%2C%20clean%20minimal%20background&width=600&height=800&seq=char-flora&orientation=portrait',
    tags: ['花系', '治愈', '女王', '温柔'],
  },
  {
    id: 'eru',
    name: '艾露·星语',
    alias: 'Eru Starfall',
    title: '星轨引路者',
    workId: 'star-field',
    work: '星野之森',
    categoryId: 'star-spirit',
    category: '星之精灵',
    element: '星',
    seiyuu: 'kamiya',
    seiyuuName: '神谷凉子',
    rank: 3,
    popularity: 92,
    summary: '背负星之预言的神秘书使，冷静知性，是星野之森的智囊担当。',
    description: '艾露·星语出自《星野之森》，是掌管星辰轨迹的引路者，寡言而通透。她总能在漫天星图中读出世界走向，也因此常年稳居星之精灵人气榜前列。艾露擅长以星光编织结界与瞬移之门，冷峻的外表下藏着一句温柔的口头禅「星星从不说谎」。其银白长发与冰蓝色瞳孔极具辨识度。',
    image: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20calm%20mysterious%20star%20spirit%20girl%20with%20long%20silver%20white%20hair%20and%20ice%20blue%20eyes%2C%20holding%20a%20glowing%20constellation%20sphere%2C%20night%20sky%20with%20stars%20behind%2C%20soft%20painterly%20magical%20style%2C%20emerald%20and%20gold%20palette%2C%20clean%20minimal%20background&width=600&height=800&seq=char-eru&orientation=portrait',
    tags: ['星系', '智囊', '神秘', '高冷'],
  },
  {
    id: 'nora',
    name: '诺拉·幽兰',
    alias: 'Nora Shadowleaf',
    title: '暗影猎手',
    workId: 'moonlight',
    work: '月光回廊',
    categoryId: 'dark-elf',
    category: '暗夜精灵',
    element: '暗',
    seiyuu: 'kurosaki',
    seiyuuName: '黑崎真奈',
    rank: 4,
    popularity: 90,
    summary: '游走于月光回廊的暗夜精灵刺客，果断凌厉，人气居高不下。',
    description: '诺拉·幽兰是《月光回廊》中最具压迫感的暗夜精灵，擅长潜行与影刃，出手果决。她背负被诅咒的影之纹章，却始终坚持自己的正义。诺拉的「月光瞬影」连招流畅华丽，配合黑崎真奈低沉克制的嗓音，让无数观众直呼「又飒又心疼」。她长期占据暗系角色人气榜前三。',
    image: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20determined%20dark%20elf%20assassin%20with%20short%20black%20hair%20and%20sharp%20green%20eyes%2C%20holding%20a%20shadow%20blade%2C%20moonlit%20corridor%20with%20purple%20and%20emerald%20moonlight%2C%20soft%20painterly%20magical%20style%2C%20deep%20emerald%20palette%2C%20clean%20minimal%20background&width=600&height=800&seq=char-nora&orientation=portrait',
    tags: ['暗系', '刺客', '酷飒', '人气榜'],
  },
  {
    id: 'shione',
    name: '汐音·泉',
    alias: 'Shione Spring',
    title: '深渊咏者',
    workId: 'abyss-mirror',
    work: '深渊水镜',
    categoryId: 'elemental',
    category: '元素精灵',
    element: '水',
    seiyuu: 'fujiwara',
    seiyuuName: '藤原千夏',
    rank: 5,
    popularity: 88,
    summary: '以歌声抚慰深渊的水之精灵，治愈系声线是她的招牌。',
    description: '汐音·泉来自《深渊水镜》，是镇守深海结界的水之咏者。她以「咏潮之诗」平息海啸、唤醒迷途者，温柔声线极具感染力，被誉为水系的「治愈天花板」。汐音能化身为潮汐之灵穿梭水域，其浅青长发与珍珠泪痣令人过目难忘，是新手入坑水系的绝佳选择。',
    image: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20gentle%20water%20spirit%20girl%20with%20light%20teal%20hair%20and%20a%20pearl%20beauty%20mark%2C%20singing%20with%20flowing%20water%20and%20bubbles%20around%20her%2C%20underwater%20magical%20scene%2C%20soft%20painterly%20style%2C%20emerald%20and%20cream%20palette%2C%20clean%20minimal%20background&width=600&height=800&seq=char-shione&orientation=portrait',
    tags: ['水系', '治愈', '咏者', '温柔'],
  },
  {
    id: 'tia',
    name: '提亚·晨露',
    alias: 'Tia Dew',
    title: '森林守护者',
    workId: 'star-field',
    work: '星野之森',
    categoryId: 'forest-elf',
    category: '森林精灵',
    element: '木',
    seiyuu: 'takahashi',
    seiyuuName: '高桥美月',
    rank: 6,
    popularity: 85,
    summary: '与古树共鸣的森林守护者，开朗元气，是森林精灵的人气担当。',
    description: '提亚·晨露是《星野之森》的森林守护者，能与千年古树对话、以枝叶化形御敌。她性格元气满满，总在树冠间跳跃，腰间别着随身小葫芦。提亚的笑声由高桥美月倾情演绎，明快而富有生命力，让「早安，晨露」成为观众每日打卡的台词。',
    image: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20cheerful%20forest%20elf%20girl%20with%20moss%20green%20hair%20and%20leaf%20clothing%2C%20holding%20a%20small%20wooden%20flask%2C%20sunlit%20magical%20forest%20with%20fireflies%2C%20soft%20painterly%20style%2C%20emerald%20and%20gold%20palette%2C%20clean%20minimal%20background&width=600&height=800&seq=char-tia&orientation=portrait',
    tags: ['木系', '守护者', '元气', '开朗'],
  },
  {
    id: 'lorin',
    name: '洛林·羽',
    alias: 'Lorin Feather',
    title: '翼兽行者',
    workId: 'wind-spirit',
    work: '风之精灵使',
    categoryId: 'phantom-beast',
    category: '幻兽精灵',
    element: '翼',
    seiyuu: 'sato',
    seiyuuName: '佐藤健一',
    rank: 7,
    popularity: 82,
    summary: '与天翼幻兽缔结契约的少年行者，热血可靠。',
    description: '洛林·羽是《风之精灵使》中能与天翼幻兽「白隼王」共鸣的行者少年。他热血直率，常在关键时刻挺身而出，是团队最坚实的盾。佐藤健一以清爽而富有爆发力的声线，将洛林从莽撞少年到独当一面的成长刻画得格外动人。其羽翼纹身与白隼随行的形象极具辨识度。',
    image: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20youthful%20brave%20spirit%20boy%20with%20short%20white%20hair%20and%20wing%20tattoo%2C%20a%20white%20falcon%20companion%20on%20his%20shoulder%2C%20sky%20and%20clouds%20background%2C%20soft%20painterly%20magical%20style%2C%20emerald%20and%20cream%20palette%2C%20clean%20minimal%20background&width=600&height=800&seq=char-lorin&orientation=portrait',
    tags: ['幻兽', '热血', '伙伴', '成长'],
  },
  {
    id: 'maru',
    name: '玛尔·金穗',
    alias: 'Maru Goldspike',
    title: '麦田守望者',
    workId: 'phantom-night',
    work: '幻夜妖精',
    categoryId: 'forest-elf',
    category: '森林精灵',
    element: '金',
    seiyuu: 'tanaka',
    seiyuuName: '田中莉奈',
    rank: 8,
    popularity: 79,
    summary: '守护金色麦田的森林精灵，温柔可靠的大姐姐型角色。',
    description: '玛尔·金穗是《幻夜妖精》中的麦田守望者，金发垂肩、笑容温暖。她能催熟谷物、招来丰收之雨，是村落信赖的「穗之母」。玛尔平日持重温柔，战斗时却会化身挥动金色巨镰的守护者。田中莉奈的声线温厚中带着力量，让这个角色兼具烟火气与神圣感。',
    image: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20warm%20golden%20haired%20forest%20elf%20woman%20in%20peasant%20robe%20holding%20a%20golden%20scythe%2C%20golden%20wheat%20field%20at%20sunset%2C%20soft%20painterly%20magical%20style%2C%20gold%20and%20cream%20palette%2C%20clean%20minimal%20background&width=600&height=800&seq=char-maru&orientation=portrait',
    tags: ['木系', '丰收', '大姐姐', '温暖'],
  },
  {
    id: 'yuna',
    name: '尤娜·月蚀',
    alias: 'Yuna Eclipse',
    title: '月之祭司',
    workId: 'moonlight',
    work: '月光回廊',
    categoryId: 'dark-elf',
    category: '暗夜精灵',
    element: '月',
    seiyuu: 'saotome',
    seiyuuName: '早乙女瑠璃',
    rank: 9,
    popularity: 77,
    summary: '背负月之契约的暗夜祭司，清冷优雅，悲情色彩浓厚。',
    description: '尤娜·月蚀是《月光回廊》的暗夜祭司，以月华驱动蚀之仪式，优雅而疏离。她与诺拉互为宿命双生，背负着无法言说的诅咒。早乙女瑠璃以清冷空灵的音色演绎尤娜，让「月蚀之夜」的独白成为全剧泪点。其月白长发与深紫眼影极具艺术感，是暗系美学爱好者的心头好。',
    image: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20melancholic%20elegant%20dark%20elf%20priestess%20with%20long%20moonwhite%20hair%20and%20purple%20eye%20makeup%2C%20moonlit%20ritual%20with%20eclipse%20symbols%2C%20soft%20painterly%20magical%20style%2C%20deep%20emerald%20and%20silver%20palette%2C%20clean%20minimal%20background&width=600&height=800&seq=char-yuna&orientation=portrait',
    tags: ['月系', '祭司', '优雅', '悲情'],
  },
  {
    id: 'sherry',
    name: '雪莉·铃兰',
    alias: 'Sherry Lily',
    title: '冬日花使',
    workId: 'flower-crown',
    work: '花冠物语',
    categoryId: 'flower-fairy',
    category: '花之妖精',
    element: '铃兰',
    seiyuu: 'okamoto',
    seiyuuName: '冈本由纪',
    rank: 10,
    popularity: 74,
    summary: '掌管寒冬铃兰的花使少年，清冽灵动，人气稳步上升。',
    description: '雪莉·铃兰是《花冠物语》中反季绽放的冬之花使，银发少年，眉眼清冽。他能令风雪中绽开铃兰，性子却有几分俏皮，常与主角芙洛拉拌嘴。冈本由纪以清亮少年音演绎，赋予角色灵气与反差萌，让雪莉在花系角色中迅速圈粉。',
    image: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20playful%20silver%20haired%20flower%20spirit%20boy%20with%20lily%20of%20the%20valley%20flowers%2C%20snowy%20winter%20garden%20with%20bellflowers%20blooming%2C%20soft%20painterly%20magical%20style%2C%20cool%20cream%20and%20emerald%20palette%2C%20clean%20minimal%20background&width=600&height=800&seq=char-sherry&orientation=portrait',
    tags: ['花系', '冬日', '少年', '灵动'],
  },
  {
    id: 'zen',
    name: '泽恩·极光',
    alias: 'Zen Aurora',
    title: '极光剑士',
    workId: 'phantom-night',
    work: '幻夜妖精',
    categoryId: 'star-spirit',
    category: '星之精灵',
    element: '光',
    seiyuu: 'ishida',
    seiyuuName: '石田航',
    rank: 11,
    popularity: 71,
    summary: '挥舞极光之剑的星之剑士，沉稳坚毅，守护幻夜世界的安宁。',
    description: '泽恩·极光是《幻夜妖精》中的星之剑士，手持以极光凝成的圣剑「破晓」。他沉稳内敛，话不多却总能一剑定局。石田航以低沉厚重的声线塑造角色，使泽恩的每一次拔剑都充满分量感。其藏青长发与流光剑刃相映，是星系角色中少见的阳刚担当。',
    image: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20steady%20star%20spirit%20swordsman%20with%20dark%20navy%20long%20hair%20holding%20a%20glowing%20aurora%20sword%2C%20polar%20light%20sky%20background%2C%20soft%20painterly%20magical%20style%2C%20emerald%20and%20gold%20palette%2C%20clean%20minimal%20background&width=600&height=800&seq=char-zen&orientation=portrait',
    tags: ['光系', '剑士', '沉稳', '守护'],
  },
  {
    id: 'sera',
    name: '塞拉·焰',
    alias: 'Sera Flame',
    title: '熔心裁决者',
    workId: 'abyss-mirror',
    work: '深渊水镜',
    categoryId: 'elemental',
    category: '元素精灵',
    element: '火',
    seiyuu: 'otsuka',
    seiyuuName: '大塚美里',
    rank: 12,
    popularity: 69,
    summary: '掌控地心之焰的元素精灵，强势霸道，反差感十足。',
    description: '塞拉·焰是《深渊水镜》的地火使者，掌管熔岩与净焰，性格强势、护短而纯粹。她看似暴躁，却会偷偷用火苗为迷途的小妖取暖，反差感十足。大塚美里的声线极具张力，将塞拉「燃尽一切不公」的气势完美释放，是火系角色中的硬核担当。',
    image: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20fiery%20elemental%20spirit%20girl%20with%20vivid%20orange%20red%20hair%20and%20glowing%20flame%20motifs%2C%20commanding%20pose%20with%20fire%20erupting%20around%20her%2C%20volcanic%20magical%20scene%2C%20soft%20painterly%20style%2C%20warm%20gold%20and%20emerald%20palette%2C%20clean%20minimal%20background&width=600&height=800&seq=char-sera&orientation=portrait',
    tags: ['火系', '裁决', '强势', '反差'],
  },
];

// 按人气排序的角色榜（前 10）
export const topRankedCharacters: AnimeCharacter[] = [...characters]
  .sort((a, b) => b.popularity - a.popularity)
  .slice(0, 10);